/** Presentation scope only. Never use a theme ID as a tenant/database key. */
export const COUNTER_CULTURE_THEME = "counter-culture";
export const COUNTER_CULTURE_BRAND_KEY = "rolls_and_brew";
export function applyBrandTheme(brandKey, root) {
  const element = root || (typeof document !== "undefined" ? document.documentElement : null);
  if (!element) return false;
  if (brandKey === COUNTER_CULTURE_BRAND_KEY) {
    element.setAttribute("data-brand-theme", COUNTER_CULTURE_THEME);
    return true;
  }
  element.removeAttribute("data-brand-theme");
  return false;
}
export function bootstrapBrandTheme() {
  return applyBrandTheme(process.env.REACT_APP_BRAND_KEY || COUNTER_CULTURE_BRAND_KEY);
}
